module.exports = __webpack_public_path__ + "img/smr.3b1c9fb5.svg";